var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12.867mm",
    height: "11.711mm",
    viewBox: "0 0 12.867 11.711",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-107.27 -131.08)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m114.18 135.66s-6.7427 4.7146-6.9185 7.1271c0.71594 7e-3 1.2967-0.0138 1.2967-0.0138s-0.34724-0.23048 1.5441-2.1329c1.968 1.7882 5.1769 1.2981 6.9791-0.31145s3.0557-2.8036 3.0472-9.2519c-3.5484 1.4885-3.9644 0.79351-7.4469 1.2267s-5.9255 4.1382-3.7235 7.0211c1.056-1.2555 4.9664-4.045 4.9664-4.045z",
    fill: "#70ad47",
    style: {
      paintOrder: "stroke fill markers"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.66de82e1b0af59f335be39aa88ffe05c.svg";
export { ForwardRef as ReactComponent };